<template>
  <div class="product-info" :class="{ 'has-height': type !== 'deal', 'is-deal': type === 'deal', 'no-border': (productInfo.dealType == DEAL_TYPES.BO_DELETED_DEAL && productInfo.rejectedOffer && !productInfo.rejectedOffer.offerAcceptedDate) }">
    <div class="image-wrapper">
      <img width="64" :src="productInfo.imageUrl" />
    </div>
    <div class="content-wrapper">
      <template v-if="type === 'deal'">
        <TooltipPlugin
          :tooltipText="productInfo.title"
          position="bottom-end"
          :tooltipWidth="250"
        >
          <template #tooltip-btn>
            <div class="title" :class="{isClickable, 'is-deal': type === 'deal'}" @click="isClickable && $emit('click')">{{ productInfo.title }}</div>
          </template>
        </TooltipPlugin>
      </template>
      <div v-else class="title" :class="{isClickable}" @click="isClickable && $emit('click')">{{ productInfo.title }}</div>
      <div class="product-code">
        <div v-if="productInfo.productCode" class="code">
          <span>Ürün Kodu:</span>
          <span>{{ productInfo.productCode }}</span>
        </div>
        <div v-if="productInfo.stockCode" class="code">
          <span>Stok Kodu:</span>
          <span>{{ productInfo.stockCode }}</span>
        </div>
        <div v-if="productInfo.commissionRate" class="code">
          <span>Komisyon Oranı:</span>
          <span>%{{ productInfo.commissionRate }}</span>
        </div>
        <div v-if="productInfo.commission" class="code">
          <span>Komisyon Tutarı:</span>
          <span>{{ productInfo.commission }} TL</span>
        </div>
        <div v-if="productInfo.stock" class="code">
          <span>Stok:</span>
          <span>{{ productInfo.stock }}</span>
        </div>
      </div>
    </div>
  </div>
  <div v-if="productInfo.dealType == DEAL_TYPES.BO_DELETED_DEAL && productInfo.rejectedOffer && productInfo.rejectedOffer.offerAcceptedDate" class="deal-content-wrapper">
    <div class="code">
      <p>
        Sonlandırılmış olan bu tekliften,<br />
        {{ productInfo.rejectedOffer.offerAcceptedDate }} - {{ productInfo.rejectedOffer.offerRejectedDate }}, 
        arasında ₺{{ productInfo.rejectedOffer.offerPrice }} satış fiyatı ve 
        %{{ productInfo.rejectedOffer.commission }} komisyon ile faydalandınız.
      </p>
    </div>
  </div>
  <div v-if="productInfo.dealType == DEAL_TYPES.NEW_DEAL" class="deal-content-wrapper">
    <div class="code">
      <p>
        Eski tekliften vazgeçmediğiniz durumda,<br />
        {{ productInfo.acceptedOffer.startDate }} - {{ productInfo.acceptedOffer.finishDate }}, 
        arasında ₺{{ productInfo.acceptedOffer.price }} satış fiyatı ve 
        %{{ productInfo.acceptedOffer.commission }} komisyon ile faydalanmaya devam edeceksiniz.
      </p>
    </div>
  </div>
  <div v-if="productInfo.dealType != DEAL_TYPES.BO_DELETED_DEAL && type === 'deal'" class="deal-content-wrapper">
    <div v-if="productInfo.startDate" class="code">
      <span>Başlangıç:</span>
      <span>{{ productInfo.startDate }}</span>
    </div>
    <div v-if="productInfo.finishDate" class="code">
      <span>Bitiş:</span>
      <span>{{ productInfo.finishDate }}</span>
    </div>
  </div>
</template>

<script>
import { TooltipPlugin } from '@n11/so-ui-components';
import { DEAL_TYPES } from '@/utils/enum/offerStatus';
export default {
  name: 'ProductInfoCell',
  emits: ['click'],
  props: {
    productInfo: {
      type: Object,
      required: true,
    },
    isClickable: {
      type: Boolean,
      required: false,
    },
    type: {
      type: String,
      required: false,
      enum: ['default', 'deal'],
      default: 'default'
    }
  },
  components: {
    TooltipPlugin,
  },
  data() {
    return {
      DEAL_TYPES
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.product-info {
  gap: 8px;
  display: flex;
  align-items: center;
  margin: 12px 12px 8px 12px;
  padding-bottom: 8px;

  .image-wrapper {
    width: 64px;
    min-width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    border: 0.5px solid $colorD40;
    overflow: hidden;

    img {
      max-width: 100%;
      max-height: 100%;
      width: fit-content;
    }
  }

  .content-wrapper {
    height: 100%;
    width: 100%;

    .title {
      width: auto;
      min-height: 32px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 12px;
      font-weight: 600;
      line-height: 16px;
      margin-bottom: 4px;
      color: $colorN80;

      &.isClickable {
        color: $colorN80;
        cursor: pointer;
      }

      &.is-deal {
        -webkit-line-clamp: 4 !important;
        line-clamp: 4 !important;
      }
    }

    .product-code {
      gap: 2px;
      display: flex;
      flex-direction: column;

      .code {
        gap: 4px;
        display: flex;

        > span {
          font-size: 11px;
          line-height: 14px;

          &:first-child {
            font-weight: 600;
            color: $colorD40;
          }

          &:last-child {
            font-weight: 400;
            color: $colorN80;
          }
        }
      }
    }
  }

  &.hunt {
    margin: unset;

    .content-wrapper {
      .title {
        max-width: 224px;
        text-decoration: none;
        color: $colorN80;
      }
    }
  }

  &.is-deal:not(.no-border) {
    border-bottom: 0.5px solid $colorN30;
  }
}

.deal-content-wrapper {
  padding: 0 12px;
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding-bottom: 12px;
  
  .code {
    gap: 2px;
    display: flex;
    flex-direction: column;
    flex: 1;

    > span {
      font-size: 11px;
      line-height: 14px;

      &:first-child {
        font-weight: 400;
        color: $colorN60;
      }

      &:last-child {
        font-weight: 600;
        color: $colorN80;
      }
    }

    > p {
      font-size: 11px;
      line-height: 14px;
      max-width: 318px;
      width: 100%;
    }
  }
}
</style>
